import { render } from "./KRSubHeaderSkeleton.vue?vue&type=template&id=5b8251e7&scoped=true"
import script from "./KRSubHeaderSkeleton.vue?vue&type=script&lang=js"
export * from "./KRSubHeaderSkeleton.vue?vue&type=script&lang=js"

import "./KRSubHeaderSkeleton.vue?vue&type=style&index=0&id=5b8251e7&lang=scss&scoped=true"
import "./KRSubHeaderSkeleton.vue?vue&type=style&index=1&id=5b8251e7&lang=scss"
script.render = render
script.__scopeId = "data-v-5b8251e7"

export default script